import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { isDefined } from '@sama/js-core';
import { map } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../../../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-right-collapsing-panel',
  templateUrl: './right-collapsing-panel.component.html',
  styleUrls: ['./right-collapsing-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RightCollapsingPanelComponent {
  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);

  isInSplitView$ = this.taskWorkspaceStore('splitViewOutputName').$.pipe(
    map(isDefined),
  );
}
